import { render, staticRenderFns } from "./EditButtonsContainer.vue?vue&type=template&id=237f8e8e&"
import script from "./EditButtonsContainer.vue?vue&type=script&lang=js&"
export * from "./EditButtonsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports